import type { ClientAccount, Quote, VideoTestimonial } from './schema'

export const proofPage = {
  eyebrow: 'Proof',
  titleThin: 'The people who',
  titleBold: 'kept me on.',
  bands: { videos: 'On camera', quotes: 'In the community', clients: 'Client accounts' },
  lede: 'The client accounts I run, two clips from clients, and what people in the community wrote after working with me.',
}

/** Client names stay anonymised, as on v1. The roles and the work are real. */
export const clientAccounts: ClientAccount[] = [
  {
    label: 'Client 1',
    role: 'Operations Manager & GHL Specialist',
    work: 'I run their GoHighLevel end to end: CRM, workflows, A2P and email, courses and membership, so it keeps moving on its own.',
    tags: ['GHL build', 'Automation', 'Membership'],
    logo: { src: '/images/clients/64/authority-drift.webp', alt: 'Client 1 logo', width: 64, height: 64 },
  },
  {
    label: 'Client 2',
    role: 'GHL Specialist & Agentic AI Engineer',
    work: 'I build inside their GoHighLevel: the ticketing system, branded forms, and workflows, plus the SOPs that keep it running.',
    tags: ['CRM', 'Pipelines', 'Forms'],
    logo: { src: '/images/clients/connekt.png', alt: 'Client 2 logo', width: 128, height: 128 },
  },
  {
    label: 'Client 3',
    role: 'Web Dev & GHL Specialist',
    work: 'I build and maintain the web side and the GoHighLevel behind it: site, landing pages, forms, and automations that book calls.',
    tags: ['Web dev', 'GHL', 'Automation'],
  },
]

export const videoTestimonials: VideoTestimonial[] = [
  {
    id: 'client-clip-1',
    src: '/media/client-testimonial.mp4',
    poster: '/media/client-testimonial-poster.jpg',
    width: 640,
    height: 360,
    duration: '0:28',
    label: 'Client testimonial 1',
    published: '2026-06-06', // first on v1: commit 66cfc5f
  },
  {
    id: 'client-clip-2',
    src: '/media/client-testimonial-2.mp4',
    poster: '/media/client-testimonial-2-poster.jpg',
    width: 464,
    height: 832,
    duration: '0:52',
    label: 'Client testimonial 2',
    published: '2026-09-03', // first on v1: commit 89cb26b
  },
]

/** Written feedback, verbatim from v1. Only named, dated quotes are used. */
export const communityQuotes: Quote[] = [
  {
    name: 'Richard Lobres',
    context: 'HL Accelerator chat',
    date: 'May 4, 2026',
    text: 'Kenneth is incredibly generous in sharing his knowledge with the group and consistently goes above and beyond, committing long hours in the chat to guide fellow HLA members who are new to advanced AI skills.',
  },
  {
    name: 'John Hill',
    context: 'HL Accelerator session',
    date: 'May 3, 2026',
    text: 'BrewedOps is such a great platform. Resume, Job Board, Claude Code, and a lot more, all easy to find and navigate. The ACG3 Discord session Kenneth hosted was full of practical tools and guidance. He breaks topics down in a way that just clicks. Highly recommend BrewedOps and these sessions to anyone looking to level up.',
  },
  {
    name: 'Yhen Faith Gagan',
    context: 'BrewedOps toolkit',
    date: 'Mar 30, 2026',
    text: 'This toolkit is so phenomenal. Every tool in here can make your life easy, especially for any GoHighLevel user. I really love the UI. Kuddos to you, Kenneth. You are indeed unstoppable, literally one of the community angels.',
  },
  {
    name: 'Erica Mhay Torrelino',
    context: 'Claude Code teaching',
    date: 'May 5, 2026',
    text: 'Thank you so much for sharing your knowledge. You explain things clearly and make learning easy to understand.',
  },
]
